import { render } from "./App.vue?vue&type=template&id=557f4aff&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=557f4aff&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=557f4aff&lang=css"
script.render = render
script.__scopeId = "data-v-557f4aff"

export default script